<template>
  <div>
    <section class="section">
      <div class="container">
        <div class="content">
          <div class="field">
            <div class="control has-icons-left has-icons-right">
              <input
                class="input is-large"
                type="text"
                v-model="search"
                placeholder="Buscar"
              />
              <span class="icon is-medium is-left">
                <i class="material-icons">search</i>
              </span>
              <span class="icon is-medium is-right">
                <i class="fas fa-check fa-lg"></i>
              </span>
            </div>
          </div>
          <table class="table">
            <thead>
              <tr>
                <th></th>
                <th>Datos</th>
                <th>Pruebas</th>
                <th v-if="isAdmin">Estatus</th>
                <th style="width:200px;" v-if="isAdmin">Items</th>
                <th>Controles</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(info, index) in filteredItems" :key="index">
                <td>
                  <span>{{ index + 1 }}</span>
                </td>
                <td>
                  <span class="subtitle is-5">{{ info.nombre }}</span>
                  <span>| {{ info.cliente ? info.cliente.nombre : "" }}</span>
                  <span>{{ info.cliente ? info.cliente.nit : "" }}</span>
                </td>
                <td>
                  <span
                    class="tag is-info"
                    v-for="(k, v) in info.pruebas"
                    :key="v"
                    >{{ k }}</span
                  >
                </td>
                <td v-if="isAdmin">
                  <div class="control">
                    <div class="select">
                      <select v-model="info.status" @change="selectItem(info)">
                        <option v-for="(k, v) in selectstatus" :key="v">{{
                          k
                        }}</option>
                      </select>
                    </div>
                  </div>
                </td>
                <td v-if="isAdmin">
                  <div v-for="(k, v) in info.pruebas" :key="v">
                    <strong>{{ k }}</strong>
                    <div v-for="(k1, v1) in item[k]" :key="v1">
                      <input
                        class="is-checkradio is-dark"
                        type="checkbox"
                        :id="info._id + k + v1"
                        @change="selectItem(info)"
                        v-model="info.items[k][k1.d]"
                      />
                      <label :for="info._id + k + v1">{{ k1.nombre }}</label>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="field is-grouped" v-if="isAdmin">
                    <p class="control">
                      <router-link
                        class="button is-link tooltip"
                        data-tooltip="Estadisticos"
                        :to="{
                          name: 'estadisticos',
                          params: { procesoid: info._id },
                        }"
                      >
                        <span class="icon">
                          <i class="material-icons">functions</i>
                        </span>
                      </router-link>
                    </p>
                    <p class="control">
                      <button
                        class="button is-info tooltip"
                        data-tooltip="Editar datos"
                        @click="getStructure(info)"
                      >
                        <span class="icon">
                          <i class="material-icons">rule</i>
                        </span>
                      </button>
                    </p>
                    <p class="control">
                      <button
                        class="button is-danger tooltip"
                        data-tooltip="Eliminar"
                        @click="eliminar(info)"
                      >
                        <span class="icon">
                          <i class="material-icons">delete_forever</i>
                        </span>
                      </button>
                    </p>
                    <p class="control">
                      <button
                        class="button is-link tooltip"
                        style="background-color: #2DC84E !important"
                        data-tooltip="Descargar Datos Agrupados"
                        @click="excelInfo(info._id)"
                      >
                        <span class="icon">
                          <i class="material-icons">library_books</i>
                        </span>
                      </button>
                    </p>
                  </div>
                  <div class="has-text-centered" v-if="!isAdmin">
                    <button
                      class="button is-link"
                      style="background-color: #2DC84E !important"
                      data-tooltip="Descargar Datos Agrupados"
                      @click="excelInfo(info._id)"
                    >
                      <span class="icon">
                        <i class="material-icons">library_books</i>
                      </span>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import apiServices from "@/services/yungol-services";
import { mapState } from "vuex";

const XLSX = require("xlsx");

const filterItems = (query, data) => {
  return data.filter((el) => {
    if (!el.cliente) {
      el.cliente = {
        nombre: "Sin cliente",
        nit: "",
      };
    }
    const texto = el.nombre + el.cliente.nombre + el.cliente.nit;
    if (texto.toLowerCase().indexOf(query.toLowerCase()) > -1) {
      return el;
    }
  });
};

export default {
  data() {
    return {
      selectstatus: [
        "Creado",
        "En Proceso",
        "En Revision",
        "Revisado",
        "Ajustes",
        "Enviado",
      ],
      search: "",
      datos: [],
      item: {
        clima: [
          {
            d: "e",
            nombre: "Estandarizadas",
          },
          {
            d: "pm",
            nombre: "Porcentajes",
          },
          {
            d: "m",
            nombre: "Directa",
          },
        ],
        beneficios: [
          {
            d: "e",
            nombre: "Estandarizadas",
          },
          {
            d: "pm",
            nombre: "Porcentajes",
          },
          {
            d: "m",
            nombre: "Directa",
          },
        ],
        compromiso: [
          {
            d: "me",
            nombre: "Estandarizadas",
          },
          {
            d: "m",
            nombre: "Directa",
          },
        ],
        felicidad_a: [
          {
            d: "m",
            nombre: "Sin Selección",
          },
        ],
        demograficos: [
          {
            d: "c",
            nombre: "Conteo",
          },
        ],
      },
      nombreVariables: {
        apjef: "Jefe",
        claor: "Claridad",
        train: "Trato",
        disre: "Recursos",
        aop: "Apoyo Org.",
        esta: "Estabilidad",
        retri: "Retribución",
        coher: "Coherencia",
        senpe: "Pertenencia",
        tequi: "Equipo",
        cc: "Clima",
        coop: "Cooperación",
        respo: "Responsabilidad",
        respe: "Respeto",
        est: "Estímulo",
        apoy: "Apoyo",
        parti: "Participación",
        ig: "Imagen Gerencial",
        ie: "Imagen Empresa",
        cvrel: "Imagen Relaciones",
        eng: "Engagement",
        cafec: "Compromiso Afectivo",
        ccont: "Compromiso de Continuidad",
        cnorm: "Compromiso Normativo",
        perfil: "Perfil",
        eaptra_a: "Disfrute en el trabajo",
        gratra_a: "Gratificación en el trabajo",
        sentra_a: "Sentido en el trabajo",
        eapvid_a: "Estado Afectivo Positivo en la Vida",
        gravid_a: "Gratificación en la Vida",
        senvid_a: "Sentido en la Vida",
        f_tra_a: "Felicidad en el trabajo",
        f_vid_a: "Felicidad en la Vida",
        vida_a: "",
        eaptra_b: "Disfrute en el trabajo.",
        gratra_b: "Gratificación en el trabajo.",
        sentra_b: "Sentido  en el trabajo.",
        eapvid_b: "Estado Afectivo Positivo en la Vida.",
        gravid_b: "Gratificación en la Vida.",
        senvid_b: "Sentido en la Vida.",
        f_tra_b: "Felicidad en el trabajo.",
        f_vid_b: "Felicidad en la Vida.",
        benef: "Beneficios",
        satis: "Satisfacción",
        demograficos: "Demográficos",
      },
      isAdmin: false,
    };
  },
  computed: {
    ...mapState(["idtoken", "modalnotification", "tokenUser"]),
    filteredItems: function() {
      return filterItems(this.search, this.datos);
    },
    resultnotification() {
      return this.modalnotification.result.aceptar;
    },
  },
  methods: {
    getStructure(info) {
      if (info.structure) {
        this.$store.commit("setStructure", info.structure);
      } else {
        this.$store.commit("setStructure", { grupos: [] });
      }
      this.$router.replace({ name: "dataeditor", params: { id: info._id } });
    },
    async selectItem(i) {
      const _this = this;
      const d = i;
      try {
        await apiServices.put(`/dato`, d);
        _this.traeData(_this);
      } catch (err) {
        console.log(err);
      }
    },
    async traeData(_this) {
      let result;
      try {
        result = await apiServices.get(`/datos`);
        _this.datos = [];
        result.data.forEach((k) => {
          const d = {};
          const keys1 = Object.keys(k);
          keys1.forEach(function(k1) {
            if (k1 !== "pruebas") {
              d[k1] = k[k1];
            } else {
              const pruebas = [];
              k[k1].forEach(function(k2) {
                if (k2 === "benef") {
                  pruebas.push("beneficios");
                } else {
                  pruebas.push(k2);
                }
              });
              d["pruebas"] = pruebas;
            }
          });
          if (!k.items) {
            d.items = {};
            d.pruebas.forEach((k1) => {
              d.items[k1] = {};
            });
          } else {
            d.pruebas.forEach((k1) => {
              if (!d.items[k1]) {
                d.items[k1] = {};
              }
            });
          }
          _this.datos.push(d);
        });
      } catch (err) {
        console.log(err);
      }
    },
    async deleteInforme(_this, id) {
      try {
        await apiServices.delete(`/dato/${id}`);
        _this.traeData(_this);
      } catch (err) {
        console.log(err);
      }
    },
    eliminar(inf) {
      this.$store.commit("changenotificationmodal", {
        info: {
          title: "¡Cuidado!",
          message: "¿Realmente desea eliminar el dato?",
          clase: "is-white",
          data: inf._id,
        },
      });
    },
    varNombres(cod) {
      var vars = this.nombreVariables;
      for (let index = 0; index < Object.keys(vars).length; index++) {
        if (vars[cod] !== undefined) {
          return vars[cod];
        } else {
          return "null";
        }
      }
    },
    widthCols(data) {
      let values = [];
      //  Se recorre todos los datos
      for (let i = 0; i < data.length; i++) {
        let cont = 0;
        // Se recorre la informacion de un Dato
        for (const d in data[i]) {
          // Si es la primera iteracion arma el dato con el tamaño del campo y lo guarda la array values
          if (i === 0) {
            let w = { width: String(data[i][d]).length + 2 };
            values.push(w);
          }
          //  Si no es la primera iteracion compara los datos nuevo con los valores del array values
          //  con el fin de extraer el numero mas grande
          else {
            let w = String(data[i][d]).length + 2;
            if (values[cont].width < w) {
              values[cont].width = w;
            }
            cont++;
          }
        }
      }
      // Se valian los tamaños de los titulos para evitar corte de texto en el Excel
      let cont = 0;
      for (const key in data[0]) {
        let w = String(key).length + 2;
        if (values[cont].width < w) {
          values[cont].width = w;
        }
        cont++;
      }

      //  Se devuelve values con el formato necesario para el tamaño de columnas del Excel
      return values;
    },
    async excelInfo(idinf) {
      let result;
      const id = idinf;

      try {
        result = await apiServices.get(`/informes/${id}`);

        let rows = result.data.rows;
        let data = [];
        for (let i = 0; i < rows.length; i++) {
          let row = {};
          for (const key of Object.keys(rows[i])) {
            if (key === "Grupo" || key === "SubGrupo") {
              Object.assign(row, { [key]: rows[i][key] });
            } else {
              let name = this.varNombres(key);
              // console.log(name, key);
              if (rows[i][key].e || rows[i][key].c) {
                Object.assign(row, {
                  [name]: rows[i][key].e
                    ? rows[i][key].e.toFixed(2)
                    : rows[i][key].c,
                });
              } else {
                // No se agrega
              }
            }
          }
          data.push(row);
        }

        this.excel({
          data: [data],
          names: [result.data.nombre],
        });
      } catch (err) {
        console.log(err);
        this.$store.dispatch("notify", {
          message: `Hubo un problema no se pudo generar el excel`,
          type: "is-danger",
        });
      }
    },
    async excel(dato) {
      try {
        let data = dato;
        if (data.data.length > 0) {
          //  Recorremos las diferentes datas creando un Excel para cada uno
          for (let i = 0; i < data.data.length; i++) {
            //  Asignamos la informacion necesaria a nuevas variables
            let dataExc = data.data[i];
            let name = data.names[i];
            //  Se agrega la data al libro de excel
            var ws = XLSX.utils.json_to_sheet(dataExc);

            //  Se configura el tamaño de cada columna
            const widths = this.widthCols(dataExc);
            ws["!cols"] = widths;

            //  Se crea el libro con la data agregada, se le da un nombre y finalizando se descarga
            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Hoja1");
            var nombreArchivo = name + ".xlsx";
            XLSX.writeFile(wb, nombreArchivo);
          }
        } else {
          this.$store.dispatch("notify", {
            message: `No hay datos para descargar`,
            type: "is-link",
          });
        }
      } catch (err) {
        console.log(err);
        this.$store.dispatch("notify", {
          message: `Hubo un problema no se pudo generar el excel`,
          type: "is-danger",
        });
      }
    },
  },
  watch: {
    idtoken(newv, oldv) {
      if (newv) {
        this.traeData(this);
      }
    },
    resultnotification(nv, ov) {
      if (nv) {
        this.deleteInforme(this, this.modalnotification.result.data);
      }
    },
  },
  created() {
    if (this.tokenUser["admin"]) {
      this.isAdmin = true;
    }
    if (this.idtoken) {
      this.traeData(this);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/data/ListData.vue